const initialFilterState = {
  agronomist: [] as string[],
  packageStatus: [] as string[],
  shipmentStatus: [] as string[],
  soNumber: null as string | null,
  farmerGroup: [] as string[],
  isViewingStuckPackages: false,
  isViewingPackagesWithoutInvoice: false,
  dateRange: null as [string, string] | null,
};

export enum FilterType {
  SET_AGRONOMIST = 'SET_AGRONOMIST',
  SET_PACKAGE_STATUS = 'SET_PACKAGE_STATUS',
  SET_SHIPMENT_STATUS = 'SET_SHIPMENT_STATUS',
  SET_SO_NUMBER = 'SET_SO_NUMBER',
  SET_FARMER_GROUP = 'SET_FARMER_GROUP',
  TOGGLE_STUCK_PACKAGES = 'TOGGLE_STUCK_PACKAGES',
  TOGGLE_PACKAGES_WITHOUT_INVOICE = 'TOGGLE_PACKAGES_WITHOUT_INVOICE',
  SET_DATE_RANGE = 'SET_DATE_RANGE',
  RESET_FILTERS = 'RESET_FILTERS',
}

type FilterAction =
  | { type: FilterType.SET_AGRONOMIST; payload: string[] }
  | { type: FilterType.SET_PACKAGE_STATUS; payload: string[] }
  | { type: FilterType.SET_SHIPMENT_STATUS; payload: string[] }
  | { type: FilterType.SET_SO_NUMBER; payload: string | null }
  | { type: FilterType.TOGGLE_STUCK_PACKAGES; payload: boolean }
  | { type: FilterType.TOGGLE_PACKAGES_WITHOUT_INVOICE; payload: boolean }
  | { type: FilterType.SET_FARMER_GROUP; payload: string[] }
  | { type: FilterType.SET_DATE_RANGE; payload: [string, string] | null }
  | { type: FilterType.RESET_FILTERS; payload: void };

function filterReducer(state: typeof initialFilterState, action: FilterAction) {
  switch (action.type) {
    case FilterType.SET_AGRONOMIST:
      return { ...state, agronomist: action.payload };
    case FilterType.SET_PACKAGE_STATUS:
      return { ...state, packageStatus: action.payload };
    case FilterType.SET_SHIPMENT_STATUS:
      return { ...state, shipmentStatus: action.payload };
    case FilterType.SET_SO_NUMBER:
      return { ...state, soNumber: action.payload };
    case FilterType.SET_FARMER_GROUP:
      return { ...state, farmerGroup: action.payload };
    case FilterType.TOGGLE_STUCK_PACKAGES:
      return {
        ...state,
        ...initialFilterState,
        packageStatus: action.payload ? ['shipped', 'delivered'] : [],
        isViewingStuckPackages: action.payload,
        dateRange: state?.dateRange,
      };
    case FilterType.TOGGLE_PACKAGES_WITHOUT_INVOICE:
      return {
        ...state,
        ...initialFilterState,
        packageStatus: action.payload ? ['shipped', 'delivered'] : [],
        isViewingPackagesWithoutInvoice: action.payload,
        dateRange: state?.dateRange,
      };
    case FilterType.SET_DATE_RANGE:
      return { ...state, dateRange: action.payload };
    case FilterType.RESET_FILTERS:
      return initialFilterState;
    default:
      return state;
  }
}

export { initialFilterState, filterReducer };
